import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row } from 'react-bootstrap';
import { Link } from 'react-router';
import AuthorizedComponent from '../../../components/AuthorizedComponent';
import { determineRequiredRoleForAbnormalityType } from '../../../shared/security/roleDeterminator';
import { ROLES, STATUSES } from '../../../constants';

const AbnormalityActionButtons = ({
    abnormality,
    abnormalityType,
    handleAssignAbnormalityToMe,
    handleCancelAbnormalityModal,
    handleCloseAbnormalityModal,
    handleCreateAbnormality,
    handleUpdateAbnormality,
    runId,
}) => {
    const CREATOR = determineRequiredRoleForAbnormalityType(abnormalityType, 'CREATOR');
    const CLOSER = determineRequiredRoleForAbnormalityType(abnormalityType, 'CLOSER');
    const CANCELLER = determineRequiredRoleForAbnormalityType(abnormalityType, 'CANCELLER');

    const isCancelled = abnormality && abnormality.abnormalityStatus === STATUSES.CANCELLED;
    const isClosed = abnormality && abnormality.abnormalityStatus === STATUSES.CLOSED;
    const canUpdate = !isCancelled && !isClosed;

    return (
        <Row style={{ textAlign: 'right', marginRight: 20, marginBottom: 40 }}>
            {!!runId && (
                <Link to={`/runs/${runId}`}>
                    <Button bsStyle="default">Back to run details</Button>
                </Link>
            )}
            {!abnormality && (
                <AuthorizedComponent requiredRoles={[ROLES[CREATOR]]}>
                    <Button
                        bsStyle="success"
                        style={{ marginLeft: 20 }}
                        onClick={handleCreateAbnormality}
                    >
                        Create abnormality
                    </Button>
                </AuthorizedComponent>
            )}
            {abnormality &&
                !isCancelled &&
                !isClosed && (
                    <AuthorizedComponent requiredRoles={[ROLES[CLOSER]]}>
                        <Button
                            bsStyle="primary"
                            style={{ marginLeft: 20 }}
                            onClick={() =>
                                handleAssignAbnormalityToMe(
                                    abnormality && abnormality.abnormalityId
                                )
                            }
                        >
                            Assign to me
                        </Button>
                    </AuthorizedComponent>
                )}
            {abnormality &&
                canUpdate && (
                    <AuthorizedComponent requiredRoles={[ROLES[CREATOR]]}>
                        <Button
                            bsStyle="success"
                            style={{ marginLeft: 20 }}
                            onClick={handleUpdateAbnormality}
                        >
                            Update abnormality
                        </Button>
                    </AuthorizedComponent>
                )}
            {abnormality &&
                !isCancelled &&
                !(abnormality && abnormality.abnormalityStatus !== 'ASSIGNED') && (
                    <AuthorizedComponent requiredRoles={[ROLES[CANCELLER]]}>
                        <Button
                            bsStyle="warning"
                            style={{ marginLeft: 20 }}
                            onClick={handleCancelAbnormalityModal}
                        >
                            Cancel abnormality
                        </Button>
                    </AuthorizedComponent>
                )}
            {abnormality &&
                !isClosed &&
                abnormality &&
                (abnormality.abnormalityStatus === 'ACTION_TAKEN' ||
                    abnormality.abnormalityStatus === 'ACTIONS_EXECUTED' ||
                    (abnormality.abnormalityStatus === 'ASSIGNED' &&
                        abnormality.recoveryActions.length === 0)) && (
                    <AuthorizedComponent requiredRoles={[ROLES[CLOSER]]}>
                        <Button
                            bsStyle="danger"
                            style={{ marginLeft: 20 }}
                            onClick={handleCloseAbnormalityModal}
                        >
                            Close abnormality
                        </Button>
                    </AuthorizedComponent>
                )}
        </Row>
    );
};

AbnormalityActionButtons.propTypes = {
    abnormalityType: PropTypes.string.isRequired,
};

export default AbnormalityActionButtons;
